import { ChargePoint as IChargePoint } from '../common/redux/api/web-api'
import { UserState } from '../common/redux/features/user/userSlice'

import { CurrentUser } from './currentUser'
import hasClaimForCompany from './hasClaimForCompany'
import Claims from './claims'
import { isPartnerDomain, isUserappDomain } from './currentDomain'

const isConnectorOwner = (user: CurrentUser, chargePoint: IChargePoint) => {
    for (const connector of chargePoint.connectors ?? []) {
        if (user.id === connector.connectorUserId) return true
    }

    return false
}

const isOwnerWithEditPermission = (user: CurrentUser, chargePoint: IChargePoint) => {
    return (user.id === chargePoint.ownerId || isConnectorOwner(user, chargePoint)) && !chargePoint.ownerReadOnly
}

const isCompanyAdmin = (user: CurrentUser, chargePoint: IChargePoint) =>
    chargePoint.companyId && hasClaimForCompany(user, chargePoint.companyId, Claims.Admin)

export default function canEditChargePoint(chargePoint?: IChargePoint, user?: CurrentUser | UserState | null): boolean {
    if (isPartnerDomain) return false

    if (!chargePoint) return false

    if (!user) return false

    if (user.isSuperAdmin) return true

    if (isOwnerWithEditPermission(user, chargePoint)) return true

    if (isCompanyAdmin(user, chargePoint)) return true

    if (isUserappDomain && chargePoint.ownerReadOnly) return false

    return false
}
